var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.7002C17.2084 17.7002 20.0662 19.3805 22.1289 22.0059C22.4019 22.3533 22.3416 22.8559 21.9941 23.1289C21.6467 23.4019 21.1441 23.3416 20.8711 22.9941C19.0408 20.6647 16.6132 19.2998 14 19.2998C11.3868 19.2998 8.95916 20.6647 7.1289 22.9941C6.85594 23.3416 6.35328 23.4019 6.00586 23.1289C5.65844 22.8559 5.59813 22.3533 5.87109 22.0059C7.93381 19.3805 10.7915 17.7002 14 17.7002ZM17.7002 10C17.7002 7.95655 16.0435 6.2998 14 6.2998C11.9565 6.2998 10.2998 7.95655 10.2998 10C10.2998 12.0435 11.9565 13.7002 14 13.7002C16.0435 13.7002 17.7002 12.0435 17.7002 10ZM19.2998 10C19.2998 12.9271 16.9271 15.2998 14 15.2998C11.0729 15.2998 8.70019 12.9271 8.70019 10C8.70019 7.07289 11.0729 4.7002 14 4.7002C16.9271 4.7002 19.2998 7.07289 19.2998 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActors);
export default __webpack_public_path__ + "static/media/actors.d2f348dd0e8853c91bae1fe8a966292c.svg";
export { ForwardRef as ReactComponent };